import { initials } from '@v2/features/shipments/utils';

const SIZE_CLASS = {
    sm: 'h-7 w-7 text-[10px]',
    md: 'h-9 w-9 text-xs',
} as const;

/** Cor estável por nome (legível em avatar). */
function colorForName(name: string): string {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;

    return `hsl(${hue} 42% 42%)`;
}

type Props = {
    names: string[];
    maxVisible?: number;
    size?: keyof typeof SIZE_CLASS;
    className?: string;
};

export default function ClientAvatars({ names, maxVisible = 4, size = 'sm', className = '' }: Props) {
    const list = names.map((n) => n.trim()).filter(Boolean);

    if (list.length === 0) {
        return <span className="text-xs text-gray-400">—</span>;
    }

    const visible = list.slice(0, maxVisible);
    const remaining = list.length - visible.length;
    const box = SIZE_CLASS[size];

    return (
        <div
            className={`flex items-center -space-x-2 ${className}`}
            title={list.join('\n')}
        >
            {visible.map((name) => (
                <span
                    key={name}
                    title={name}
                    className={`inline-flex shrink-0 items-center justify-center rounded-full border-2 border-white font-bold text-white shadow-sm ring-1 ring-gray-200 ${box}`}
                    style={{ backgroundColor: colorForName(name) }}
                >
                    {initials(name)}
                </span>
            ))}
            {remaining > 0 ? (
                <span
                    title={list.slice(maxVisible).join('\n')}
                    className={`inline-flex shrink-0 items-center justify-center rounded-full border-2 border-white bg-gray-100 font-bold text-gray-600 ring-1 ring-gray-200 ${box}`}
                >
                    +{remaining}
                </span>
            ) : null}
        </div>
    );
}
